// actions.js
export const INIT_REPORT_REQUEST = 'INIT_REPORT_REQUEST';
export const ADD_REPORT = 'ADD_REPORT';
export const ADD_MACHINE_BY_COMPANYID_FOR_REPORT = 'ADD_MACHINE_BY_COMPANYID_FOR_REPORT';
export const ERROR_REPORT_REQUEST = 'ERROR_REPORT_REQUEST';

// actions.js
export function initReportRequest() {
    return { type: INIT_REPORT_REQUEST };
}

export function addReport(data) {
    return { type: ADD_REPORT, payload: data };
}

export function machineByCompanyIdforreport(data) {
    return { type: ADD_MACHINE_BY_COMPANYID_FOR_REPORT, payload: data };
}
export function errorReportRequest(error) {
    return { type: ERROR_REPORT_REQUEST, payload: error };
}
